import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'account',
  label: 'Account Section',
  description: 'User dashboard with orders, history and settings.',
  supportedPages: ['account'],
  variants: [{ id: 'v1', label: 'V1 (Tabbed Interface)' }],
  commonFields: [
    { key: 'tabOverviewLabel', label: 'Overview Tab Label', type: 'string', default: 'Overview' },
    { key: 'tabOrdersLabel', label: 'Orders Tab Label', type: 'string', default: 'Orders' },
    { key: 'tabAddressesLabel', label: 'Addresses Tab Label', type: 'string', default: 'Saved Locations' },
    { key: 'tabDetailsLabel', label: 'Profile Tab Label', type: 'string', default: 'Profile Info' },
    { key: 'signOutLabel', label: 'Sign Out Label', type: 'string', default: 'Sign Out' },
    { key: 'signinRedirectPath', label: 'Sign In Redirect Path', type: 'string', default: '/signin' },
  ],
}
